const LOCALSTORAGE_ACCESS_TOKEN = "ACCESS_TOKEN";
const LOCALSTORAGE_REFRESH_TOKEN = "REFRESH_TOKEN";
const LOCALSTORAGE_USER_PHONE = "userPhone";
const LOCALSTORAGE_USER_ID = "userId";
const LOCALSTORAGE_USER_EMAIL = "userEmail";
const LOCALSTORAGE_SITE_ID = "siteId";
const LOCALSTORAGE_SELLER_ID = "sellerId";
const LOCALSTORAGE_BANK_CODE = "bankCode";
const getLSUserInfo = () => {
  return {
    accessToken: localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN) || void 0,
    userId: localStorage.getItem(LOCALSTORAGE_USER_ID) || "",
    phone: localStorage.getItem(LOCALSTORAGE_USER_PHONE) || void 0,
    bankCode: localStorage.getItem(LOCALSTORAGE_BANK_CODE) || void 0,
    refreshToken: localStorage.getItem(LOCALSTORAGE_REFRESH_TOKEN) || void 0,
    email: localStorage.getItem(LOCALSTORAGE_USER_EMAIL) || void 0,
    siteId: localStorage.getItem(LOCALSTORAGE_SITE_ID) || void 0,
    sellerId: localStorage.getItem(LOCALSTORAGE_SELLER_ID) || void 0
  };
};
const setLSUserInfo = (user) => {
  localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN, user.accessToken || "");
  localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN, user.refreshToken || "");
  localStorage.setItem(LOCALSTORAGE_BANK_CODE, user.bankCode || "");
  localStorage.setItem(LOCALSTORAGE_USER_PHONE, user.phone || "");
  localStorage.setItem(LOCALSTORAGE_USER_ID, user.userId);
  localStorage.setItem(LOCALSTORAGE_USER_EMAIL, user.email || "");
  localStorage.setItem(LOCALSTORAGE_SITE_ID, user.siteId || "");
  localStorage.setItem(LOCALSTORAGE_SELLER_ID, user.sellerId || "");
};
class UserManager {
  get tekoID() {
    return window.TekoID;
  }
  onPartnerLoggedIn(userInfo) {
    setLSUserInfo(userInfo);
  }
  onLoggedOut() {
    [
      LOCALSTORAGE_ACCESS_TOKEN,
      LOCALSTORAGE_REFRESH_TOKEN,
      LOCALSTORAGE_BANK_CODE,
      LOCALSTORAGE_USER_PHONE,
      LOCALSTORAGE_USER_ID,
      LOCALSTORAGE_USER_EMAIL,
      LOCALSTORAGE_SITE_ID,
      LOCALSTORAGE_SELLER_ID
    ].forEach((lsKey) => localStorage.removeItem(lsKey));
  }
  getAccessToken() {
    var _a, _b, _c, _d;
    let accessToken, isLoggedIn = false;
    accessToken = (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.getAccessToken();
    if (!accessToken) {
      accessToken = localStorage == null ? void 0 : localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN);
      isLoggedIn = true;
    } else {
      isLoggedIn = !!((_d = (_c = this.tekoID) == null ? void 0 : _c.user) == null ? void 0 : _d.isLoggedIn());
    }
    if (accessToken && isLoggedIn)
      return accessToken;
  }
  getInfo() {
    if (this.tekoID.user) {
      const userInfo = this.tekoID.user.getUserInfo();
      return (userInfo == null ? void 0 : userInfo.sub) ? {
        userId: userInfo == null ? void 0 : userInfo.sub,
        phone: userInfo == null ? void 0 : userInfo.phone_number,
        name: userInfo == null ? void 0 : userInfo.name,
        picture: userInfo == null ? void 0 : userInfo.picture,
        email: userInfo == null ? void 0 : userInfo.email
      } : null;
    } else {
      const userInfo = getLSUserInfo();
      return (userInfo == null ? void 0 : userInfo.userId) ? {
        userId: userInfo == null ? void 0 : userInfo.userId,
        phone: userInfo == null ? void 0 : userInfo.phone,
        bankCode: userInfo == null ? void 0 : userInfo.bankCode,
        email: userInfo == null ? void 0 : userInfo.email,
        siteId: userInfo == null ? void 0 : userInfo.siteId,
        sellerId: userInfo == null ? void 0 : userInfo.sellerId
      } : null;
    }
  }
  getLSInfo() {
    return getLSUserInfo();
  }
  loadUser() {
    var _a;
    return (_a = this.tekoID.user) == null ? void 0 : _a.loadUser();
  }
  unloadUser() {
    var _a;
    return (_a = this.tekoID.user) == null ? void 0 : _a.unloadUser();
  }
}
const userManager = new UserManager();

export { userManager };
